import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";


const formatDate = (isoString) => {
  const date = new Date(isoString);
  if (date.toString() === 'Invalid Date' || date.toString() === 'Invalid Date') {
    return isoString;
  } else {
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // 12-hour format with AM/PM
      timeZone: 'Asia/Kolkata', // Indian Standard Time
    });
  }
};

const LeadHistoryModal = ({ isOpen, onClose, leadHistory, title }) => {
  return (
    <Modal
      size="2xl"
      backdrop="opaque"
      classNames={{
        body: "py-6",
        backdrop: "bg-[#000]/50 backdrop-opacity-40",
        base: "border-[#292f46] bg-[#19172c] dark:bg-[#e5f3fb] text-black",
        header: "border-b-[1px] border-[#292f46]",
        // footer: "border-t-[1px] border-[#292f46]",
        closeButton: "text-black hover:bg-white/5 active:bg-white/10",
      }}
      isOpen={isOpen}
      radius="lg"
      onOpenChange={onClose}
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-black">
              {title} Lead History
            </ModalHeader>
            <ModalBody>
              <table className="w-full text-sm text-left border border-gray-400">
                <thead className="bg-success text-white">
                  <tr>
                    <th className="p-2 border-l border-gray-400">No.</th>
                    <th className="p-2 border-l border-gray-100">Timestamp</th>
                    <th className="p-2 border-l border-gray-100">Message</th>
                    <th className="p-2 border-l border-gray-100">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {leadHistory?.length > 0 ? (
                    leadHistory
                      .slice()
                      .reverse()
                      .map((lead, i) => {
                        const rawMsg = lead?.message ?? lead?.data?.message;
                        const msgText = typeof rawMsg === "object" && rawMsg !== null
                          ? (rawMsg.message || rawMsg.error || JSON.stringify(rawMsg))
                          : (rawMsg || "N/A");

                        const rawStatus = lead?.data?.status ?? lead?.status;
                        const statusStr = typeof rawStatus === "object" && rawStatus !== null
                          ? JSON.stringify(rawStatus)
                          : String(rawStatus ?? "N/A");

                        const isSuccess =
                          rawStatus === "Success" ||
                          rawStatus === "success" ||
                          rawStatus === "Accepted" ||
                          rawStatus === "Retailed" ||
                          rawStatus === 1 ||
                          rawStatus === 200;

                        const isDanger =
                          rawStatus === "UnSuccess" ||
                          rawStatus === "Expired" ||
                          rawStatus === "Failed" ||
                          rawStatus === "Error" ||
                          rawStatus === "Rejected" ||
                          rawStatus === 2 ||
                          rawStatus === "failure" ||
                          rawStatus === 500;

                        const isPending =
                          rawStatus === "Open" ||
                          rawStatus === "Pending" ||
                          rawStatus === 3;

                        return (
                          <tr key={i} className="border border-gray-600">
                            <td className="p-4 border border-gray-600">{i + 1}</td>
                            <td className="p-4 border border-gray-600 text-nowrap">
                              {(lead?.timestamp && lead?.timestamp !== null)
                                ? formatDate(lead?.timestamp)
                                : (lead?.createdAt ? formatDate(lead?.createdAt) : "N/A")}
                            </td>
                            <td className="p-4 border border-gray-600 break-words">
                              <div>{msgText}</div>
                              {(lead?.orderId || lead?.userId) && (
                                <div className="text-xs text-gray-500 mt-1 flex flex-wrap gap-2">
                                  {lead?.orderId && (
                                    <span>Order ID: <strong className="text-gray-700 font-semibold">{lead.orderId}</strong></span>
                                  )}
                                  {lead?.userId && (
                                    <span>User ID: <strong className="text-gray-700 font-semibold">{lead.userId}</strong></span>
                                  )}
                                </div>
                              )}
                            </td>
                            <td className="p-4 border border-gray-600">
                              <span
                                className={`py-1 px-3 rounded text-white font-medium ${
                                  isSuccess
                                    ? "bg-green-500"
                                    : isDanger
                                    ? "bg-red-500"
                                    : isPending
                                    ? "bg-yellow-500 text-black"
                                    : "bg-gray-500 text-white"
                                }`}
                              >
                                {statusStr}
                              </span>
                            </td>
                          </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan="4" className="p-2 text-center text-gray-500">
                        No History Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ModalBody>
            <ModalFooter>
              {/* <Button color="foreground" variant="light" onPress={onClose}>
                Close
              </Button> */}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default LeadHistoryModal;
